<button
  mat-button
  [matMenuTriggerFor]="menu"
  [matTooltip]="'GENERAL.language' | translate"
>
  <span class="lang">{{ currentLanguage() }}</span>
</button>
<mat-menu #menu="matMenu">
  @for (lang of languages; track lang) {
    <button mat-menu-item (click)="setLaguage(lang)">
      <span class="lang-option">{{ lang }}</span>
    </button>
  }
</mat-menu>
